import { skipToken } from '@reduxjs/toolkit/query';
import Loader from 'components/Loader';
import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import { useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'store/api/projects.ts';
import { ProjectFormData } from 'types/projects';
import { useClassifiers } from 'utils/useClassifiers';
import { projectDtoToForm } from './projectFormMapping';
import ProjectPageForm from './ProjectPageForm';

const ClassicProjectPageEdit = () => {
    const { id: projectId } = useParams();
    const { data: project, isLoading, isError } = useGetProjectByIdQuery(projectId ?? skipToken);

    const { classifiers, isLoading: isLoadingClassifiers } = useClassifiers({
        codes: ['CURRENCY'],
    });
    const initialData = useMemo<ProjectFormData | undefined>(() => {
        if (project && classifiers) {
            return projectDtoToForm(project, classifiers);
        }
    }, [classifiers, project]);

    if (isLoading || isLoadingClassifiers || (initialData === undefined && !isError)) {
        return <Loader />;
    }

    return <ProjectPageForm type="edit" initialData={initialData} />;
};

/** In the new design a project is edited card by card on its page, so its edit URL opens Overview there. */
const ProjectPageEdit = () => {
    const isNew = useIsNewDesign();
    const { id: projectId } = useParams();
    return isNew ? <Navigate to={`/projects/${projectId}?edit=overview`} replace /> : <ClassicProjectPageEdit />;
};

export default ProjectPageEdit;
